export const SETTING = {
  SAVE_SETTING_USER: 'SAVE_SETTING_USER',
  SAVE_SETTING_USER_SUCCESS: 'SAVE_SETTING_USER_SUCCESS',
  SAVE_SETTING_USER_FAIL: 'SAVE_SETTING_USER_FAIL'
};
